import { Component } from 'react'
import { connect } from 'react-redux'
import { clearNotification } from '../actions/notificationActions'
import Sticky from './utils/Sticky'

class Notifier extends Component {
  componentDidUpdate() {
    // Fixes notification not appearing initially when scrolled down the page.
    window.scrollTo(window.scrollX, window.scrollY - 1)
    window.scrollTo(window.scrollX, window.scrollY + 1)
  }

  handleClose = () => {
    const { dispatch } = this.props
    dispatch(clearNotification())
  }

  render() {
    const { notification } = this.props
    if (!notification.message) return null

    return (
      <Sticky topOffset={56}>
        {({ isSticky }) => (
          <div
            className={`alerts ${
              notification.style === 'error' ? 'alert-error' : 'alert-success'
            } ${isSticky ? 'alerts-sticky' : 'alerts-fixed-top'}`}
          >
            <div className="alert alert-dismissible" role="alert">
              <button
                aria-label="Close notification"
                className="close"
                type="button"
                onClick={this.handleClose}
              >
                <span className="icon icon-close" />
              </button>
              <div dangerouslySetInnerHTML={{ __html: notification.message }} />
            </div>
          </div>
        )}
      </Sticky>
    )
  }
}

export default connect(({ notification }) => ({ notification }))(Notifier)
